import { breakpoints } from 'src/components/base';

export const SITEMODE_MOBILE = 'mobile';
export const SITEMODE_DESKTOP = 'desktop';
export const SITEMODE_BREAKPOINT = breakpoints.smallOnly;
export const getSiteMode = () =>
  IS_BROWSER &&
  'matchMedia' in window &&
  window.matchMedia(SITEMODE_BREAKPOINT).matches
    ? SITEMODE_MOBILE
    : SITEMODE_DESKTOP;
export const getBrowserState = () =>
  IS_BROWSER
    ? {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        siteMode: getSiteMode(),
      }
    : {};

export const injectScript = (source, isLoaded, numRetries = 10) =>
  new Promise((resolve, reject) => {
    if (typeof isLoaded === 'function' && isLoaded()) {
      resolve();
      return;
    }
    let retries = numRetries;
    const done = () => {
      requestAnimationFrame(() => {
        if (typeof isLoaded !== 'function' || isLoaded()) {
          resolve();
        } else if (retries >= 0) {
          retries--; // eslint-disable-line no-plusplus
          setTimeout(() => done(), 50);
        }
      });
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = source;
    script.onload = done;
    script.onerror = reject;

    (document.head || document.getElementsByTagName('head')[0]).appendChild(
      script
    );
  });

export const loadGDPRTransparencyScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = '//cogwheel.inventory.schibsted.io/prod/latest/gdpr-bundle.js';

  (document.head || document.getElementsByTagName('head')[0]).appendChild(
    script
  );
};

export default {
  getSiteMode,
  getBrowserState,
  injectScript,
};
